import { Role } from '@/constants/role.js'
const meta = { authorize: [Role.user, Role.root] }

export default [
    {
        path: '/',
        name: 'home',
        component: () => import('@pages/p-home'),
        meta,
    },
    {
        path: '/stream',
        name: 'stream',
        component: () => import('@pages/p-stream'),
        meta,
    },
    {
        path: '/archive-log',
        name: 'archive-log',
        component: () => import('@pages/p-archive-log'),
        meta,
    },
    {
        path: '*',
        component: () => import('@pages/p-home'),
        meta,
    },
]
